import React from 'react';




export default function Contacts() {
  return (
    <div>
      <p style={{padding: 10,}}>If you have any suggestions or ideas, please contact me at <i>alexander.kilyushin@gmail.com</i>.</p>
    </div>
  );
}
